/*
* RedirectRoute: Statless Componet
* to render component by condition
* else redirect to another URL
*
* - use this component under react-router-dom V4
*/

import React from 'react'
import { Redirect, Route } from 'react-router-dom'

const RedirectRoute = props => {
  const condition = props.if
  const Component = props.component
  const redirect = props.redirect

  return (
    condition
      ? <Route path={props.path} component={Component} />
      : <Redirect to={redirect}  />
  )
}
export default RedirectRoute



// WEBPACK FOOTER //
// ./src/routers/utilities/RedirectRoute.js